import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class CollectionSlider extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        const swiper = new Swiper(this, {
            modules: [Navigation],
            loop: false,
            spaceBetween: 20,
            breakpoints: {
                640: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 3,
                },
                1110: {
                    slidesPerView: 5,
                },
            },
            navigation: {
                nextEl: ".collection-button-next",
                prevEl: ".collection-button-prev",
            },
        })
    }
}

customElements.define('collection-featured-slider', CollectionSlider)
